app.controller('modalPurchaseReasonEntryCtrl', function ($scope, $uibModalInstance, params) {
    function normalizeTextValue(value) {
        return String(value === undefined || value === null ? '' : value).trim();
    }

    $scope.row = params && params.row ? params.row : {};
    $scope.title = params && params.title ? params.title : 'Isi Reason PO';
    $scope.reasonCodes = (params && params.reasonCodes ? params.reasonCodes : []).filter(function (item) {
        return item && item.reasonCode;
    });
    $scope.errorText = '';
    $scope.form = {
        poNo: $scope.row.poNo || '',
        poLineNo: $scope.row.poLineNo || 0,
        reasonCode: $scope.row.reasonCode || '',
        reasonDetail: $scope.row.reasonDetail || ''
    };

    $scope.submit = function () {
        if (!normalizeTextValue($scope.form.reasonCode)) {
            $scope.errorText = 'Reason code wajib dipilih';
            return;
        }
        if (!normalizeTextValue($scope.form.reasonDetail)) {
            $scope.errorText = 'Reason detail wajib diisi';
            return;
        }

        $uibModalInstance.close($scope.form);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});